import { GetRoleInput } from '@app/models/role.model'
import { UpdateUserInput } from '@app/models/user.model'

const BODY_GET_ROLE_FIELDS = `
    ${Object.keys(new GetRoleInput()).join('\n')}
`

const BODY_FIELDS = `
${Object.keys(new UpdateUserInput()).join('\n')}
auth_method
saml_id
allowed_hours
role {
    ${BODY_GET_ROLE_FIELDS}
		}
`

const BODY_FIELDS_WITHOUT_PASSWORD = `
${Object.keys(new UpdateUserInput())
  .filter((key) => key !== 'password')
  .join('\n')}
auth_method
saml_id
allowed_hours
role {
    ${BODY_GET_ROLE_FIELDS}
		}
`

export const UPDATE_PREFS = `
mutation update_prefs($data: updatePrefsInput!) {
    update_prefs(data: $data) {
        success
        errorText
        data {
            id
            client_id
            prefs
        }
    }
}
`

export const GET_USERS = `
query get_users {
    get_users {
        success
        errorText
        data {
            ${BODY_FIELDS_WITHOUT_PASSWORD}
        }
    }
}
`

export const UPDATE_USER = `
mutation update_user($data: updateUserInput!) {
    update_user(data: $data) {
        success
        errorText
        data {
            ${BODY_FIELDS}
        }
    }
}
`

export const GET_USER = `
query get_user($id: Float!, $client_id: Float!) {
    get_user(
        id: $id,
        client_id: $client_id
    ) {
        success
        errorText
        data {
            ${BODY_FIELDS_WITHOUT_PASSWORD}
        }
    }
}
`

export const CREATE_USER = `
mutation create_user($data: createUserInput!) {
    create_user(data: $data) {
        success
        errorText
        data {
            ${BODY_FIELDS}
        }
    }
}
`

export const DELETE_USER = `
mutation delete_user($id: Float!, $client_id: Float!) {
    delete_user(
        id: $id,
        client_id: $client_id
    ) {
        success
        errorText
        data {
            id
            full_name
        }
    }
}
`
